import { render, staticRenderFns } from "./pop_up_page.vue?vue&type=template&id=5e9d150e&scoped=true"
import script from "./pop_up_page.vue?vue&type=script&lang=ts"
export * from "./pop_up_page.vue?vue&type=script&lang=ts"
import style0 from "./pop_up_page.vue?vue&type=style&index=0&id=5e9d150e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9d150e",
  null
  
)

export default component.exports